"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sin = exports.normalizeAngle = exports.getSweepAngle = exports.cos = void 0;

var getSweepAngle = function getSweepAngle(startAngle, endAngle) {
  var sweepPercent = (startAngle >= endAngle ? 360 - Math.abs(endAngle - startAngle) : Math.abs(endAngle - startAngle)) / 360;
  return 360 * sweepPercent;
}; // Returns an angle between 0 and 359 regardless of the input (-90, 1080, etc.)


exports.getSweepAngle = getSweepAngle;

var normalizeAngle = function normalizeAngle(angle) {
  return (360 + angle) % 360;
};
/**
 * Math.cos, but works in degrees instead of radians.
 */


exports.normalizeAngle = normalizeAngle;

var cos = function cos(angle) {
  return Math.cos(angle * (Math.PI / 180));
};
/**
 * Math.sin, but works in degrees instead of radians.
 */


exports.cos = cos;

var sin = function sin(angle) {
  return Math.sin(angle * (Math.PI / 180));
};

exports.sin = sin;